import styled from "styled-components";
export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(props) => props.justify};
  width: ${props => props.width ? props.width : '100%'};
  height: ${(props) => (props.height ? props.height : "auto")};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : ""};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  padding: ${(props) => (props.padding ? props.padding : "1em")};
  background-image: ${(props) =>
    props.backgroundImage ? props.backgroundImage : ""};
  background-position: top right;
  background-attachment: fixed;
  background-size: cover;

  p {
    text-align: center;
    margin: 0.5em 0;
    max-width: 650px;
  }

  & > * {
    margin-bottom: 0.5em;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.justify ? props.justify : "space-between"};
  align-items: center;
  flex-wrap: ${(props) => (props.wrap ? props.wrap : "no-wrap")};
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "")};
  background-color: ${(props) => (props.background ? props.background : "")};

  @media all and (max-width: 991px) {
    width: 90%;
  }
  @media all and (max-width: 768px) {
    width: 90%;
    flex-wrap: ${(props) => (props.wrap ? "wrap" : "nowrap")};
  }
`;

export const Col = styled.div`
  width: ${(props) => (props.width ? props.width : "48%")};
  height: 460px;
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.alignItems ? props.alignItems : "flex-start"};
  justify-content: space-around;
  margin: 1em 8px;
  padding: 1em;
  background-image: ${(props) =>
    props.background ? `url(${props.background})` : ""};
  background-position: center;
  background-size: cover;

  p {
    font: normal normal 18px "Roboto Condensed";
    text-align: left;
  }

  p.citation {
    color: #acff24;
    font-weight: bold;
    text-align: right;
    width: 100%;
  }
  button {
    height: 45px;
    padding: 0 2em;
  }
  img {
    width: 90%;
  }

  @media all and (max-width: 991px) {
    width: 100%;

    &:nth-child(2) {
      display: none;
    }
  }
`;

export const Col2 = styled.div`
  width: ${(props) => (props.width ? props.width : "50%")};
  height: ${(props) => (props.height ? props.height : "460px")};
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.alignItems ? props.alignItems : "flex-start"};
  justify-content: ${props => props.justify ? props.justify : 'space-around'};
  background-image: ${(props) =>
    props.background ? `url(${props.background})` : ""};
  background-position: center;
  background-size: cover;
  transform: rotate(45px);

  p {
    font: normal normal 18px "Roboto Condensed";
    text-align: left;
  }

  @media all and (max-width: 768px) {
    display: ${props => props.mobile ? 'flex' : 'none'};
    width: ${props => props.mobile ? '100%' : '0'};
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  margin: 2em 0;

  & > * {
    margin: 0.375em;
  }
`;

export const Button = styled.button`
  width: 100%;
  max-width: 640px;
  height: 80px;
  background-color: #ff4800;
  color: #fff;
  font-size: 21px;

  :hover {
    color: #fff;
    background-color: #ff480095;
  }
`;

export const Heading = styled.h1`
  font-weight: bold;
  font-style: italic;
  font-family: "Roboto Condensed";
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")} !important;
  color: ${(props) => (props.color ? props.color : "#fff")};
  text-transform: ${props => props.textTransform ? props.textTransform : 'uppercase'};
  text-align: center;
  max-width: ${(props) => (props.width ? props.width : "650px")};
  width: ${(props) => (props.width ? props.width : "100%")};

  span {
    color: #acff24;
  }
  @media all and (max-width: 768px) {
    font-size: x-large;
    width: 100%;
  }
  @media all and (max-width: 586px) {
    font-size: large;
  }
`;

export const ItemHeading = styled.h1`
  font-weight: bold;
  font-style: italic;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "")};
  color: ${(props) => (props.color ? props.color : "#fff")};
  text-transform: uppercase;
  text-align: center;
  max-width: 650px;
  width: ${(props) => props.width};

  @media all and (max-width: 768px) {
    font-size: 16;
    width: 100%;
  }
  @media all and (max-width: 586px) {
    font-size: 14;
  }
`;

export const Text = styled.p``;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 345px);
  grid-auto-rows: auto;
  grid-gap: 20px;
  margin-top: 2em;

  @media all and (max-width: 1080px) {
    grid-template-columns: repeat(2, 345px);
  }

  @media all and (max-width: 768px) {
    grid-template-columns: repeat(1, 345px);
  }
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin: 0.75em 0;

  img.tick {
    width: 30px;
    height: 30px;
    margin-right: 0.75em;
  }
  p {
    font: normal normal 18px "Roboto Condensed";
    margin-bottom: 0;
  }
  p > span {
    color: #acff24;
    font-size: 20px;
  }
`;
export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1a1a1a;
  justify-content: flex-start;
  padding: 2em 1.5em;
  width: 345px;
  height: 300px;

  img.icon {
    width: 100px;
    height: auto;
  }
  p {
    font: normal normal 16px "Roboto Condensed";
  }

  & > * {
    margin-bottom: 1em;
  }
`;
export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #1a1a1a;
  justify-content: flex-start;
  padding: 1.25em 1.5em 0em 1.5em;
  width: 340px;
  height: ${(props) => (props.height ? props.height : "auto")};

  img.stat-icon {
    width: 90px;
    height: auto;
  }
  p {
    font: normal normal 16px "Roboto Condensed";
  }

  & > * {
    margin-bottom: 1em;
  }
`;

export const Testimonial = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 320px;
  height: 240px;
  background-color: #1a1a1a;
  padding: 1.75em 2em;

  img.rating {
    width: 130px;
    height: auto;
    margin-bottom: 1em;
  }
  p {
    font: normal normal 16px "Roboto Condensed";
    margin-bottom: 1em;
  }
`;
export const TooltipParagraph = styled.p`
  position: relative;

  span.hover-tooltip {
    font-size: 13px;
    width: 200px;
    position: absolute;
    background-color: #acff24;
    padding: 6px 16px;
    border-radius: 3px;
    left: 150%;
    top: -30px;
    z-index: 300;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    color: #000;
  }

  &:hover {
    span.hover-tooltip {
      left: 80%;
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Onboard/Parent/Registration/ParentRegistration.styles.ts